module.exports = __webpack_public_path__ + "img/HiwaQader-Svens.30b83a37.jpg";